export const FETCH_REQUESTED = "gallery/FETCH_REQUESTED"
export const FETCH_SUCCESS = "gallery/FETCH_SUCCESS"
export const FETCH_FAILED = "gallery/FETCH_FAILED"

export const UPDATE_FILTER = "gallery/UPDATE_FILTER"
export const FILTER_UPDATED = "gallery/FILTER_UPDATED"
export const DATA_UPDATED = "gallery/DATA_UPDATED"

export const OPEN_MODAL = "gallery/OPEN_MODAL"
export const CLOSE_MODAL = "gallery/CLOSE_MODAL"